// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-mailingManagement-index-main_right_content-27uRf","table":"components-mailingManagement-index-table-2NEi-"};


//////////////////
// WEBPACK FOOTER
// ./components/mailingManagement/index.css
// module id = 2293
// module chunks = 0